export default {
  title: 'Alergénios',
  description:
    'Por favor, tenha em atenção que este {{product}} pode conter os seguintes ingredientes ou derivados dos mesmos:',
  options: {
    dairy: 'Lacticínios/Leite',
    eggs: 'Ovos',
    fish: 'Peixe',
    gluten: 'Glúten',
    mango: 'Manga',
    peanuts: 'Amendoins',
    sesame: 'Sésamo',
    shellfish: 'Mariscos',
    soy: 'Soja',
    tree_nuts: 'Frutos de Casca Rija',
    celery: 'Aipo',
    crustaceans: 'Crustáceos',
    lupin: 'Tremoço',
    molluscs: 'Moluscos',
    mustard: 'Mostarda',
    nuts: 'Frutos Secos',
    sulphites: 'Sulfitos',
    almonds: 'Amêndoas',
    barley: 'Cevada',
    brazil_nuts: 'Castanhas do Brasil',
    cashew: 'Cajus',
    hazelnuts: 'Avelãs',
    kamut: 'Kamut',
    macadamia: 'Nozes de Macadâmia',
    oats: 'Aveia',
    pecan: 'Nozes-Pecã',
    pistachios: 'Pistácios',
    rye: 'Centeio',
    spelt: 'Espelta',
    walnuts: 'Nozes',
    wheat: 'Trigo',
    sugared_drink: 'Bebida Açucarada',
    lentils: 'Lentilhas',
    queensland_nuts: 'Nozes de Queensland',
  },
};
